<script>
import codeTable from "@/components/table";
import edit from "./edit";
import topBar from "./topbar";
import columnsConfig from "@/modules/config/columns";
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    created() {
        this.handleGetPolicyList(this.policyOption.searchQuery);
    },
    data() {
        return {
            policyOption: {
                data: [],
                pageQuery: {
                    total: 0,
                    pageSize: 20,
                    currentPage: 1,
                    pageSizeList: [20, 40, 60]
                },
                searchQuery: {
                    id: "",
                    name: "",
                    code: ""
                }
            },
            codeDetail: {},
            editOption: {
                type: 0, // 0编辑权限， 1编辑
                dialog: false
            }
        };
    },
    methods: {
        handleEdit(row, type) {
            this.editOption.type = type;
            this.editOption.dialog = true;
            this.editOption.row = row;
            this.$nextTick(() => {
                this.$refs.edit.initQuery(row);
            });
        },
        async handleGetPolicyList(params) {
            this.$loading(true);
            try {
                const { code, data } = await this.getPolicyList(params);
                this.policyOption.data = data;
            } catch (e) {
                throw e;
            } finally {
                this.$loading(false);
            }
        },
        async handleDelete(row) {
            // const id = row.id;
            // const {code} = await this.deletePolicy({id});
            // if (Object.is(code, 0)) {
            // 	this.$message.success('删除成功');
            // 	this.getPolicyList();
            // }
        },
        ...mapActions("zft", [
            "getPolicyList",
            "deleteCode",
            "editCode",
            "jsonpTest"
        ])
    },
    computed: {
        ...mapGetters("accountRules", ["codeOption"]),
        columns() {
            return columnsConfig;
        }
    },
    components: {
        codeTable,
        topBar,
        edit
    }
};
</script>
<template>
    <div class="account-list">
        <top-bar
            :handlerCodeSearch="handleGetPolicyList"
            :searchQuery="policyOption.searchQuery"
        ></top-bar>
        <code-table
            :data="policyOption.data"
            :columns="columns.accountColumns"
            :searchEvent="handleGetPolicyList"
            :pageOptions="policyOption.pageQuery"
        >
            <el-table-column
                label="操作"
                align="center"
                width="240"
                slot="operate"
            >
                <template slot-scope="scope">
                    <el-button type="success" @click="handleEdit(scope.row, 0)"
                        >编辑</el-button
                    >
                    <el-button type="success" @click="handleEdit(scope.row, 1)"
                        >密码重置</el-button
                    >
                    <el-button type="success" @click="handleDelete(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </code-table>
        <edit
            ref="edit"
            title="字段编辑"
            dialogWidth="40%"
            :codeEvent="editCode"
            :searchEvent="getPolicyList"
            :codeDetail="codeDetail"
            :editOption="editOption"
        ></edit>
    </div>
</template>
<style scoped lang="stylus">
.account-list
    padding 20px 20px 0
</style>
